<template>
  <div @contextmenu="selectComponentDEV($event, schema.model)" :class="[getSelectedDEV && 'dev-selected-component']">
    <v-textarea
      v-model="typed"
      v-bind="schema.attributesTextField"
      :counter="count"
      :maxlength="count"
      :rules="rules"
      :name="schema.model"
      :id="setId(schema.model)"
      :ref="schema.model"
      :readonly="schema.readonly"
      @blur="onBlur"
      @click:clear="clear()"
      @change="onChange"
      @focus="onFocus"
      @input="onInput"
    >
      <template v-slot:label>
        {{ schema.attributesTextField.label }}
        <span v-if="schema.rules.includes('required')" class="red--text">*</span>
      </template>
    </v-textarea>

    <h4 v-if="schema.attributesTitle.visible" v-text="schema.attributesTitle.title" v-bind="schema.attributesTitle"></h4>

    <p v-text="initialValue"></p>

    <p v-text="typed"></p>
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import rulesMixin from '@/mixins/rules-mixin';
import devComponentMixin from '@/mixins/dev-component-mixin';

import * as HANDLERS from '@/helpers/types/handlers';

export default {
  mixins: [abstractField, devComponentMixin, rulesMixin],

  data() {
    return {
      initialValue: this.value,
      typed: '',
      title: null,
      count: null
    };
  },

  created() {
    let count = this.model[`${this.schema.model}_maxlength`];
    this.count = count ? count : this.schema.attributesTextField.counter;
  },

  methods: {
    onChange: function() {
      this.value = `${this.initialValue} ${this.typed}`;
    },

    clear() {
      this.$nextTick(() => (this.model[this.schema.model] = ''));
    },
    setId(field) {
      return this.formOptions.mode === 'list' ? `${field}_${this.formOptions.index}` : field;
    }
  }
};
</script>
